import * as Scrivito from "scrivito"

import { BuildingReferencePage } from "pages/building-reference-page/BuildingReferencePage"

import { BuildingReferenceObjClass } from "./BuildingReferenceObjClass"

Scrivito.provideComponent(BuildingReferenceObjClass, ({ page }) => (
  <BuildingReferencePage key={page.id()} page={page} />
))
